export const gatewayObserverCreators: [string, any][] = [];

export function registerGatewayObserverCreator(name: string, createObserver: any): void {
  gatewayObserverCreators.push([name, createObserver]);
}
